var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.tipoCadastro === "PERMUTA"
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Pertence ao Projeto Integrado Trairão?",
                      content: _vm.qualificacao.pertenceAoProjeto
                        ? "Sim, " + _vm.qualificacao.gleba.nome
                        : "Não"
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "O interessado é o beneficiário original?",
                      content: _vm.qualificacao.beneficiarioOriginal
                        ? "Sim"
                        : "Não"
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label:
                        "O Valor da Terra Nua (VTN) foi pago integralmente?",
                      content: _vm.qualificacao.beneficiarioOriginal
                        ? "Sim"
                        : "Não"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm.tipoCadastro !== "CERTIDAO_TITULO" &&
          _vm.tipoCadastro !== "ONEROSO"
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Qual o tamanho da área deste beneficiário?",
                      content: _vm.qualificacao.area
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Qual a renda familiar?",
                      content: _vm.qualificacao.nomeRenda
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label:
                        "Este beneficiário e/ou seu cônjuge exerce cargo ou função pública em órgão fundiário?",
                      content: _vm.qualificacao.cargoPublico ? "Sim" : "Não"
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label:
                        "Este beneficiário e/ou seu cônjuge possui outro imóvel rural titulado?",
                      content: _vm.qualificacao.possuiImovelRuralTitulado
                        ? "Sim"
                        : "Não"
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label:
                        "Ocupa e explora diretamente o imóvel de forma mansa e pacífica, por si ou por seus antecessores? ",
                      content: _vm.qualificacao.ocupaImovel ? "Sim" : "Não"
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label:
                        "A principal atividade exercida por este beneficiário é a exploração agrícola do imóvel?",
                      content: _vm.qualificacao.exploracaoAgricola
                        ? "Sim"
                        : "Não"
                    }
                  }),
                  _vm.tipoCadastro === "PEAS"
                    ? _c("app-display", {
                        attrs: { label: "Situação: ", content: _vm.getSituacao }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.tipoCadastro === "CERTIDAO_TITULO"
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "É beneficiário originário?",
                      content: _vm.qualificacao.beneficiarioOriginario
                        ? "Sim"
                        : "Não"
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label:
                        "A área é georreferenciada tendo sido o Título emitido de acordo com a Lei 10.267/01? ",
                      content: _vm.qualificacao.areaGeorreferenciada
                        ? "Sim"
                        : "Não"
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "A área está matriculada?",
                      content: _vm.qualificacao.areaMatriculada ? "Sim" : "Não"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm.tipoCadastro === "ONEROSO"
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("app-display", {
                    attrs: {
                      label:
                        "Você e/ou seu cônjuge exerce cargo ou função pública em órgão fundiário?",
                      content: _vm.qualificacao.cargoPublico ? "Sim" : "Não"
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label:
                        "Você e/ou seu cônjuge possui outro imóvel rural titulado por doação?",
                      content: _vm.qualificacao.possuiImovelRuralTitulado
                        ? "Sim"
                        : "Não"
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label:
                        "Ocupa e explora diretamente o imóvel de forma mansa e pacífica, por si ou por seus antecessores há no mínimo 5 (cinco) anos?",
                      content: _vm.qualificacao.ocupaImovel ? "Sim" : "Não"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24bd8b8b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24bd8b8b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppQualificacao.vue
// module id = null
// module chunks = 